// The commission mark on the map (v2-the-deep.md §14.6, R2645, mockup
// round 088 card 15, ui-map-interface.md §6.7): a pennant on a staff.
//
// It is a glyph of its own and not a look of the map markers (R1291): a map
// marker is placed by a player, and a commission is issued by the faction.
// So every look of `mapMarker` keeps this one shape, and it is not the
// `pennant` look. The atlas bakes it once, white, with the foot of the staff
// at the origin (`fast/gfx/atlas.ts` `commissionSpecFor`); the marker layer
// tints each quad with the own faction ink (`fast/layers/markers.ts`). The
// card head and the row of FLEET · COMMISSIONS draw the same shape as SVG
// (`ui/overlay/commissions.ts` `commissionMarkSvg`).
//
// This is a leaf (`leaves.test.ts`): it paints into a context it is handed.

import { COMMISSION_MARK } from '../gen/presentation';

/** The atlas key of the mark. */
export const COMMISSION_MARK_KEY = 'commission-mark';

/** The box of the baked cell around the foot of the staff, in px at scale
 *  1: the staff rises up the -y axis, and the flag flies to +x. */
export function commissionBox(): { x: number; y: number; w: number; h: number } {
  const m = COMMISSION_MARK;
  const pad = m.staffPx;
  return { x: -pad, y: -m.hPx - pad, w: m.flagWPx + 2 * pad, h: m.hPx + 2 * pad };
}

/** The three corners of the flag: the head of the staff, the tip, and the
 *  foot of the flag on the staff. */
function flagCorners(): [number, number][] {
  const m = COMMISSION_MARK;
  return [[0, -m.hPx], [m.flagWPx, -m.hPx + m.flagHPx / 2], [0, -m.hPx + m.flagHPx]];
}

/** Paints the mark white around the origin of `ctx`. */
export function paintCommissionMark(ctx: CanvasRenderingContext2D): void {
  const m = COMMISSION_MARK;
  ctx.beginPath();
  ctx.moveTo(0, 0);
  ctx.lineTo(0, -m.hPx);
  ctx.lineWidth = m.staffPx;
  ctx.lineCap = 'round';
  ctx.strokeStyle = '#ffffff'; // mask
  ctx.stroke();
  const pts = flagCorners();
  ctx.beginPath();
  ctx.moveTo(pts[0][0], pts[0][1]);
  for (let i = 1; i < pts.length; i++) ctx.lineTo(pts[i][0], pts[i][1]);
  ctx.closePath();
  ctx.fillStyle = '#ffffff'; // mask
  ctx.fill();
}
